






































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Admin} from '@/types';
import {namespace} from 'vuex-class';

const adminModule = namespace('admin');

@Component
export default class JudgementListSummary extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  @Prop({
    required: false,
    default: {
      countOfInspectionsOfManager: 0,
      countOnAfterApprovalReady: 0,
      countOnApprovalReady: 0,
    }
  })
  readonly data!: {};
  private selectedSummary = '';

  private setSaleStatus(event: any) {
    this.selectedSummary = event.target.getAttribute('saleStatusTypes');
    this.$emit('onClickSummarySearch', this.selectedSummary);
  }
}
